<template>
    <div>
        <TopMenu></TopMenu>
        <router-view></router-view>
    </div>
</template>
<script>
import TopMenu from "@/views/topMenu.vue";
import {MusicManager} from "@/manager/musicManager";

export default {
    components: {TopMenu},
    data() {
        return {}

    },
    created() {
        MusicManager.create()

    }

}
</script>
<style lang="less">


body {
    margin: 0;
    overflow: hidden; /* 溢出隐藏 */
    //font-family: OPPOS;
}
</style>
